import http from "../../config/http";
import { GENERAR_DOCUMENTO_AUTORIZACION,
  MEDICAMENTOS_AFILIADO,
  MEDICAMENTOS_AFILIADO_DETALLE } from "../endpoints";

const generarDocumentoAutorizacion = (nap, codigoAfiliado) => {
  let configuration = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/pdf",
    },
    responseType: "blob",
  };
  return http.get(
    `${GENERAR_DOCUMENTO_AUTORIZACION}?nap=${nap}&codigoAfiliado=${codigoAfiliado}`,
    configuration
  );
};

const getAutorizacionesMedicamentosAfiliado = (codigoAfiliado) => {
  let configuration = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    },
  };
  let response = http.get(
    `${MEDICAMENTOS_AFILIADO}?codigoAfiliado=${codigoAfiliado}`,
    configuration
  );
  return response;
};

const getDetalleAutorizacionMedicamentos = (idAutorizacion) => {
  let configuration = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    },
  };
  return http.get(
    `${MEDICAMENTOS_AFILIADO_DETALLE}?idAutorizacion=${idAutorizacion}`,
    configuration
  );
};

export { 
  generarDocumentoAutorizacion,
  getAutorizacionesMedicamentosAfiliado,
  getDetalleAutorizacionMedicamentos  
};
